import React, { useEffect, useRef, useState } from "react";
import { getBaseUrl } from "../../../../../../Redux/Config/AppConfig";
import Select from "react-select";
import { toast } from "react-toastify";

const AddPackage = ({
  selectedPackage,
  setListUpdated,
  setSelectedPackage,
}) => {
  const BaseUrl = getBaseUrl();
  const closeBtnRef = useRef(null);

  const [formData, setFormData] = useState({
    package_name: "",
    package_description: "",
    package_price: "",
    room_ids: [],
  });

  const [errors, setErrors] = useState({});
  const [roomList, setRoomList] = useState([]);

  useEffect(() => {
    setErrors({});
    if (selectedPackage) {
      setFormData({
        package_name: selectedPackage.name || "",
        package_description: selectedPackage.description || "",
        package_price: selectedPackage.price?.toString() || "",
        room_ids: selectedPackage.rooms?.map((room) => room.id) || [],
      });
    } else {
      setFormData({
        package_name: "",
        package_description: "",
        package_price: "",
        room_ids: [],
      });
    }
  }, [selectedPackage]);

  useEffect(() => {
    const fetchRooms = async () => {
      try {
        let token = localStorage.getItem("token");
        let hotel_id = localStorage.getItem("hotel_id");

        const res = await fetch(`${BaseUrl}/room/room-types?hotel_id=${hotel_id}`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`,
          },
        });
        const data = await res.json();
        setRoomList(
          (data?.data?.rooms || []).map((room) => ({
            value: room.id,
            label: room.room_type || `Room ${room.room_number}`,
          }))
        );
      } catch (err) {
        console.error("Failed to fetch rooms:", err);
      }
    };

    fetchRooms();
  }, [BaseUrl]);

  const validate = () => {
    const newErrors = {};
    if (!formData.package_name.trim())
      newErrors.package_name = "Package name is required.";
    if (!formData.package_description.trim())
      newErrors.package_description = "Description is required.";
    if (
      !formData.package_price ||
      isNaN(formData.package_price) ||
      Number(formData.package_price) <= 0
    )
      newErrors.package_price = "Valid price is required.";
    // if (!formData.room_ids.length)
    //   newErrors.room_ids = "At least one room must be selected.";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleRoomChange = (selectedOptions) => {
    setFormData((prev) => ({
      ...prev,
      room_ids: selectedOptions ? selectedOptions.map((opt) => opt.value) : [],
    }));
    setErrors((prev) => ({ ...prev, room_ids: "" }));
  };

  const handleClear = () => {
    setFormData({
      package_name: "",
      package_description: "",
      package_price: "",
      room_ids: [],
    });
    setErrors({});
  };

  const handleSubmit = async () => {
    if (!validate()) return;
    let token=localStorage.getItem('token')

    const url = selectedPackage
      ? `${BaseUrl}/room/package/${selectedPackage.id}`
      : `${BaseUrl}/room/package`;
    const methodType = selectedPackage ? "PUT" : "POST";
    let hotel_id = localStorage.getItem("hotel_id");

    try {
      const res = await fetch(url, {
        method: methodType,
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
        },
        body: JSON.stringify({
          package_name: formData.package_name,
          package_description: formData.package_description,
          package_price: parseFloat(formData.package_price),
          room_ids: formData.room_ids,
          hotel_id:hotel_id
        }),
      });

      const response = await res.json();
      if (res.ok) {
        toast.success(
          selectedPackage
            ? "Package updated successfully!"
            : "Package created successfully!"
        );
        closeBtnRef.current?.click();
        setSelectedPackage(null);
        handleClear()
      } else {
        toast.error(response?.message || "Failed to submit package.");
      }
      setListUpdated((prev) => !prev);
      closeBtnRef.current?.click();
      setSelectedPackage(null);
    } catch (error) {
      console.error("Error submitting package:", error);
      handleClear()
    }
  };

  return (
    <div className="offcanvas offcanvas-end" tabIndex="-1" id="add-package">
      <div className="offcanvas-header">
        <h5 className="offcanvas-title">
          {selectedPackage ? "Edit Package" : "Add Package"}
        </h5>
        <button
          ref={closeBtnRef}
          type="button"
          className="btn-close"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
          onClick={() => setErrors({})}
        ></button>
      </div>
      <div className="offcanvas-body">
        <form>
          <div className="form-group mb-3">
            <label className="form-label text-muted">
              Package Name <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              name="package_name"
              className={`form-control ${
                errors.package_name ? "is-invalid" : ""
              }`}
              placeholder="Enter Package Name"
              value={formData.package_name}
              onChange={handleChange}
            />
            {errors.package_name && (
              <div className="invalid-feedback">{errors.package_name}</div>
            )}
          </div>

          <div className="form-group mb-3">
            <label className="form-label text-muted">
              Description <span className="text-danger">*</span>
            </label>
            <textarea
              name="package_description"
              className={`form-control ${
                errors.package_description ? "is-invalid" : ""
              }`}
              placeholder="Enter Package Description"
              value={formData.package_description}
              onChange={handleChange}
            />
            {errors.package_description && (
              <div className="invalid-feedback">
                {errors.package_description}
              </div>
            )}
          </div>

          <div className="form-group mb-3">
            <label className="form-label text-muted">
              Price <span className="text-danger">*</span>
            </label>
            <input
              type="number"
              name="package_price"
              className={`form-control ${
                errors.package_price ? "is-invalid" : ""
              }`}
              placeholder="Enter Package Price"
              value={formData.package_price}
              onChange={handleChange}
            />
            {errors.package_price && (
              <div className="invalid-feedback">{errors.package_price}</div>
            )}
          </div>

          <div className="form-group mb-3">
            <label className="form-label text-muted">
              Select Rooms 
            </label>
            <Select
              name="room_ids"
              options={roomList}
              isMulti
              classNamePrefix="select"
              onChange={handleRoomChange}
              value={roomList.filter((opt) =>
                formData.room_ids.includes(opt.value)
              )}
            />
            {errors.room_ids && (
              <div className="text-danger mt-1">{errors.room_ids}</div>
            )}
          </div>
        </form>

        <div className="d-flex">
          <button
            type="button"
            className="btn w-100 me-2 btn-secondary"
            onClick={handleClear}
          >
            Clear
          </button>
          <button
            type="button"
            className="btn w-100 btn-primary"
            onClick={handleSubmit}
          >
            {selectedPackage ? "Update" : "Save"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddPackage;
